import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import * as React from 'react';
import { MuiPickersAdapterContext } from '../../LocalizationProvider';
export function withDateAdapterProp(Component) {
  return (_ref) => {
    let {
      dateAdapter
    } = _ref,
        other = _objectWithoutPropertiesLoose(_ref, ["dateAdapter"]);

    if (dateAdapter) {
      return /*#__PURE__*/React.createElement(MuiPickersAdapterContext.Provider, {
        value: dateAdapter
      }, /*#__PURE__*/React.createElement(Component, other));
    }

    return /*#__PURE__*/React.createElement(Component, other);
  };
}